import { APP_THEME_LIGHT } from '../theme/theme-constants';
import { APP_FONT_SIZE_MEDIUM } from '../font/font-constants';
import { seedDefaultLocale } from '../intl/seed-intl';
import { seedDefaultTheme } from '../theme/seed-themes';
import { seedDefaultFont, seedDefaultFontSize } from '../font/seed-fonts';

export const APP_STATE_ACTION_TYPE_USER = 'seed_u';
// export const APP_STATE_ACTION_TYPE_FIREBASE_USER = 'seed_fu';

// Internationalization
export const APP_STATE_ACTION_TYPE_USER_LOCALE = 'seed_lo';
export const APP_STATE_ACTION_TYPE_USE_SYS_LOCALE = 'seed_uslo';
// Theme
export const APP_STATE_ACTION_TYPE_USER_THEME = 'seed_th';
export const APP_STATE_ACTION_TYPE_USE_SYS_THEME = 'seed_usth';
// Font
export const APP_STATE_ACTION_TYPE_USER_FONT = 'seed_fo';
export const APP_STATE_ACTION_TYPE_USER_FONT_SIZE = 'seed_fos';
// Route
export const APP_STATE_ACTION_TYPE_BASE_URL = 'seed_ur';

export const seedStates = {
  [APP_STATE_ACTION_TYPE_USER]: {
    type: 'json',
    default: null,
  },
  // [APP_STATE_ACTION_TYPE_FIREBASE_USER]: {
  //   type: 'json',
  //   default: null,
  // },
  // Internationalization
  [APP_STATE_ACTION_TYPE_USER_LOCALE]: {
    type: 'string',
    useConfigDefault: true,
    default: 'en',
  },
  [APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]: {
    type: 'boolean',
    useConfigDefault: true,
    default: false,
  },
  // Theme
  [APP_STATE_ACTION_TYPE_USER_THEME]: {
    type: 'string',
    useConfigDefault: true,
    default: APP_THEME_LIGHT,
  },
  [APP_STATE_ACTION_TYPE_USE_SYS_THEME]: {
    type: 'boolean',
    useConfigDefault: true,
    default: false,
  },
  // Font
  [APP_STATE_ACTION_TYPE_USER_FONT]: {
    type: 'string',
    useConfigDefault: true,
    default: 'Roboto',
  },
  [APP_STATE_ACTION_TYPE_USER_FONT_SIZE]: {
    type: 'int',
    useConfigDefault: true,
    default: APP_FONT_SIZE_MEDIUM,
  },
  // Route
  [APP_STATE_ACTION_TYPE_BASE_URL]: {
    type: 'string',
    useConfigDefault: true,
    default: '',
  },
};

export const seedStateDefaultStates = {
// Internationalization
  [APP_STATE_ACTION_TYPE_USER_LOCALE]: seedDefaultLocale,
  [APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]: false,
  // Theme
  [APP_STATE_ACTION_TYPE_USER_THEME]: seedDefaultTheme,
  [APP_STATE_ACTION_TYPE_USE_SYS_THEME]: false,
  // Font
  [APP_STATE_ACTION_TYPE_USER_FONT]: seedDefaultFont,
  [APP_STATE_ACTION_TYPE_USER_FONT_SIZE]: seedDefaultFontSize,
  // Route
  [APP_STATE_ACTION_TYPE_BASE_URL]: 'http://localhost:9999',
};
